export default __webpack_public_path__ + "static/media/iphone_fr_pwa.5d3c98ff.png";